var $ = require('jquery');

module.exports = (function(){

  if ($('body').hasClass('home')) {

    require('particlesjs');

    particlesJS.load('js-particles-wrapper', '/particlesjs-config.json', function() {
    });

    var heroItem = $('.js-hero-heading');
    var arrowDown = $('.js-angle-down');
    var first = true;

    $(arrowDown).on('click touchend', function(e) {
      $(window).scrollTop($('.front-page_hero').height() - 85 );
    });

    var index = 0;

    $(heroItem).css('height', '0');
    first && $(heroItem).eq(index).css('transition', 'none');
    first && $(heroItem).eq(index).css('height', '');
    first && $(heroItem).eq(index).css('opacity', '1');
    first = false;

    setInterval(function(){
      $(heroItem).eq(index).css('transition', 'opacity 1s linear');
      runAnimation();
    }, 5000);

    function runAnimation() {

      $(heroItem).css('opacity', '0');
      setTimeout(function(){
        $(heroItem).css('height', '0');
      }, 1000);

      setTimeout(function(){
        $(heroItem).eq(index).css('height', '');
        $(heroItem).eq(index).css('opacity', '1');
      }, 1000);

      index < $(heroItem).length - 1 ? index++ : index = 0;

    }

  }

})();



// WEBPACK FOOTER //
// ./components/hero_slide.js